module.exports = __webpack_public_path__ + "img/testimonials2.9018240f.jpg";